<template>
    <div class="item-container">
      <div class="simple-item" :class="{'fractionHeight': fractionBool, 'set-font-size' : setfontSize}">
        <div class="simple-item-line" :class="addClass"></div>
        <div class="simple-item-t">{{title}}</div>
        <div class="simple-item-v"><span :class="isNegativeNum?'negative_num_color':''">{{value}}</span></div>
      </div>
    </div>

</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SimpleItem',
  props: ['title', 'value', 'addClass', 'isNegativeNum'],
  data () {
    return {}
  },

  components: {},

  computed: {
    ...mapState(['graph', 'setfontSize']),
    unit () {
      return this.graph.unit
    },
    fractionBool () {
      if (this.unit === 'T_FEET_FRACTION' || this.unit === 'T_INCH_FRACTION') {
        return true
      } else {
        return false
      }
    }
  },

  mounted () {},

  methods: {}
}

</script>
<style scoped>
.simple-item {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  background-color: rgba(0,0,0,.6);
  margin-top: 2px;
  position: relative;
}

.simple-item-line {
  width: 4px;
  height: 100%;
  float: left;
  /* margin: 5px; */
  margin-right: 10px;
}

.simple-item-t {
 color: #fff;
}

.simple-item-v {
 position: absolute;
 right: 15px;
 bottom: 0px;
 color: #fff;
}

.param-color-green {
  background-color: #ed843d;
}

.param-color-violet {
  background-color: #6666ff;
}

.param-color-orange {
  background-color: #ffff00;
}

.param-color-black {
  background-color: #000000;
}

.fractionHeight {
  height: 50px;
}

</style>



// WEBPACK FOOTER //
// src/view/graph/Simple/simpleItem.vue